import React, { useState } from "react";
import { Link } from "react-router-dom";
import organic from "assets/img/organic.png";
import newlogo from "assets/img/newlogo.png";
import iptlogo from "assets/img/IPT Logo.png";

export default function AdminNavbar() {
  const [showMenu, setShowMenu] = useState(false);

  const handleMenuToggle = () => {
    setShowMenu(!showMenu);
  };

  const closeMenu = () => {
    setShowMenu(false);
  };

  const [showProductPage, setShowProductPage] = useState(false);
  const [showServicesPage, setShowServicesPage] = useState(false);

  const handleProductToggle = () => {
    setShowProductPage(true);
    setShowServicesPage(false);
  };

  const handleServicesToggle = () => {
    setShowServicesPage(true);
    setShowProductPage(false);
  };

  const handleClose = () => {
    setShowProductPage(false);
    setShowServicesPage(false);
  };
  return (
    <>
      <section className="poppins">
        {/* Navbar */}
        <nav className="fixed top-0 z-10 w-full flex items-center justify-between bg-white lg:hidden md:block">
          <div className="w-full flex items-center justify-between px-4 ">
            {/* Logo */}
            <Link to="/homepage1">
              <img className="w-48 md:w-48 -ml-6" src={iptlogo} alt="organic" />
            </Link>

            {/* Menu Toggle Button */}
            <div
              className="text-black font-bold p-4 text-2xl cursor-pointer"
              onClick={handleMenuToggle}
            >
              ☰
            </div>
          </div>
        </nav>

        {/* Sidebar & Overlay */}
        {showMenu && (
          <>
            {/* Overlay */}
            <div
              className="bg-black opacity-50 fixed top-0 left-0 w-full h-full z-40"
              onClick={closeMenu}
            ></div>

            {/* Sidebar */}
            <div
              className={`bg-white text-black fixed top-0 right-0 h-full z-50 transition-transform duration-500 ${
                showMenu ? "translate-x-0" : "translate-x-full"
              }`}
              style={{ width: window.innerWidth >= 768 ? "60%" : "100%" }}
            >
              {/* Sidebar Header */}
              <div className="flex justify-between py-4 px-6 items-center border-b">
                <Link to="/homepage1">
                  <img
                    className="w-40 md:-ml-4 -ml-6"
                    src={iptlogo}
                    alt="Junior Logo"
                  />
                </Link>
                <div
                  onClick={closeMenu}
                  className="text-black font-semibold text-xl cursor-pointer"
                >
                  ✕
                </div>
              </div>

              {/* Sidebar Menu */}
              <ul className="flex flex-col py-4 px-6 space-y-4">
                <li>
                  <Link
                    to="/homepage1"
                    className="text-lg font-semibold text-black block"
                  >
                    Home
                  </Link>
                </li>

                <li>
                  <a
                    href="/about-us"
                    className="text-lg font-semibold text-black block pt-4"
                  >
                    About
                  </a>
                </li>

                {/* Product Dropdown */}
                {showProductPage ? (
                  // Full Page Product Dropdown View
                  <div className="fixed inset-0 bg-white z-50 flex flex-col">
                    <div className="flex justify-between items-center px-4 py-4 shadow-md">
                      <h1 className="text-lg font-semibold text-black block">
                        Products
                      </h1>
                      <button
                        onClick={handleClose}
                        className="text-2xl font-bold"
                      >
                        &times;
                      </button>
                    </div>
                    <ul className="p-6 space-y-3">
                      <li>
                        <a href="/evoguard" className="block text-lg text-para">
                        Evoguard GmbH
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a href="/Ampcopumps"
                          className="block text-lg text-para mt-2"
                        >
                          Ampco pumps
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                       <a href="/Perfinoxsa"
                          className="block text-lg text-para mt-2"
                        >
                         Perfinox S.A
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a href="/HSTMaschinenbau"
                          className="block text-lg text-para mt-2"
                        >
                         HST Maschinenbau
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                ) : (
                  // Default Navbar View
                  <ul className="space-y-2">
                    {/* Product Dropdown Button */}
                    <li className="relative">
                      <button
                        className="w-full flex justify-between items-center mt-4 bg-white"
                        onClick={handleProductToggle}
                      >
                        <h1 className="text-lg font-semibold text-black block ">
                          Product
                        </h1>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 transition-transform duration-300"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </button>
                    </li>
                  </ul>
                )}

                {/* Services Dropdown */}
               
                {showServicesPage ? (
                  // Full Page services Dropdown View
                  <div className="fixed inset-0 bg-white z-50 flex flex-col">
                    <div className="flex justify-between items-center px-4 py-4 shadow-md">
                      <h1 className="text-lg font-semibold text-black block">
                        Services
                      </h1>
                      <button
                        onClick={handleClose}
                        className="text-2xl font-bold"
                      >
                        &times;
                      </button>
                    </div>
                    <ul className="p-6 space-y-3">
                      <li>
                        <a href="/service" className="block text-lg text-para">
                        Cheese Plants
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                          href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Dairy Plants
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Juice
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Beverages
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                       <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Water Plants
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Personal Care
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                       <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Cosmetics
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Culinary
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                       <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Chocolate & Sweets
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Edible Oil
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                       <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          
                          Confectioneries
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Pharmaceuticals
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                          Spices
                        </a>
                      </li>
                      <hr className="border-blue-50 mt-2" />
                      <li>
                        <a
                        href="/service"
                          className="block text-lg text-para mt-2"
                        >
                         Chemical
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                ) : (
                  // Default Navbar View
                  <ul className="space-y-2">
                    {/* Product Dropdown Button */}
                    <li className="relative">
                      <button
                        className="w-full flex justify-between items-center mt-4 bg-white"
                        onClick={handleServicesToggle}
                      >
                        <h1 className="text-lg font-semibold text-black block ">
                          Services
                        </h1>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 transition-transform duration-300"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </button>
                    </li>
                  </ul>
                )}

                <li>
                  <Link
                    to="/contact"
                    className="text-lg font-semibold text-black block mt-4"
                  >
                    Contact Us
                  </Link>
                </li>

                <div className="w-6/12 mt-6">
                  <a href="/contact">
                    <button className="blue text-white px-4 py-2  rounded-md">
                      Get A Quote
                    </button>
                  </a>
                </div>
              </ul>
            </div>
          </>
        )}
      </section>
    </>
  );
}
